// Based on BE validator https://gitlab.cendis.cz/edaz/backend/all-in-one-be/-/merge_requests/1637/diffs#diff-content-eab7cef754e7727c5b7899169d44540bfa186bbe

export default function isPaymentOrderText(value: string | undefined) {
  const regex = /^('|\(|\)|\+|,|-|\.|:|\/|\?| |[0-9]|[a-z]|[A-Z])*$/;

  if (value) {
    return regex.test(value);
  }

  return true;
}
